/**
 * @param {unknown} value
 * @returns {boolean}
 */
export function isValidHttpUrl(value) {
  if (value == null || typeof value !== "string") return false;
  try {
    const u = new URL(value);
    return u.protocol === "http:" || u.protocol === "https:";
  } catch {
    return false;
  }
}
